const styles = {
  container: {
    background: 'linear-gradient(to bottom, #4a68b5 0%, #3b5598 100%)',
    margin: '-22px -22px 20px',
    borderTopRightRadius: '8px',
    borderTopLeftRadius: '8px',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '75px 20px',
    position: 'relative'
  },
  intro: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '60%'
  },
  title: {
    fontSize: '24px',
    lineHeight: '26px',
    margin: 0
  },
  location: {
    fontSize: '16px',
    lineHeight: '18px',
    margin: 0
  },
  details: {
    fontSize: '16px',
    margin: 0,
    '& a': {
      color: '#fff',
      textDecoration: 'none',
      marginRight: '10px',
      '&:hover': {
        opacity: 0.8
      }
    }
  },
  avatar: {
    fontSize: '110px',
    marginRight: '14px'
  },
  school: {
    maxWidth: '60%'
  },
  cover: {
    position: 'absolute',
    zIndex: '10',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: '0.08',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    filter: 'grayscale(1)',
    pointerEvents: 'none'
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #dedede',
    margin: '0 -22px',
    paddingBottom: '30px'
  },
  banner: {
    borderRadius: '4px',
    background: '#cce8fb',
    color: '#008bec',
    border: '1px solid #99d1f7',
    boxShadow: 'none',
    display: 'inline-block',
    padding: '10px',
    margin: '0 auto',
    textAlign: 'center',
    position: 'relative',
    '& a': {
      color: '#008bec',
      fontWeight: 'bold',
      textDecoration: 'none'
    },
    '&:after, &:before': {
      position: 'absolute',
      content: '""',
      display: 'block',
      width: '2px',
      height: '3px',
      borderStyle: 'solid',
      borderWidth: '10px'
    },
    '&:before': {
      borderColor: 'transparent transparent #99d1f7 transparent',
      top: '-23px',
      left: '49%'
    },
    '&:after': {
      borderColor: 'transparent transparent #cce8fb transparent',
      top: '-22px',
      left: '49%'
    }
  }
}

export default styles
